import styled, { css } from 'styled-components';

import StarFilled from '@/icons/xsmall/Star-filled.svg';

export const StyledStar = styled(StarFilled)<{ $filled: boolean }>`
  ${({ $filled }) =>
    $filled
      ? css`
          color: var(--color-testimonials-filled-star);
        `
      : css`
          color: var(--color-testimonials-empty-star);
        `}
`;

export const StyledFluidStar = styled.svg`
  color: var(--color-testimonials-filled-star);
`;

export const StyledStarStopFill = styled.stop`
  stop-color: var(--color-testimonials-filled-star);
`;

export const StyledStarStopBackground = styled.stop`
  stop-color: var(--color-testimonials-empty-star);
`;
